import { Typography, ListItem, Divider } from "@mui/material";
import { GridEx } from "components/MuiExtras/Grid/GridEx";
import MuiLink from "components/MuiExtras/MuiLink";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import AppResource from "components/Translations/AppResources";
import { GlobalSearchItem } from "models/ApiModels";
import * as React from "react";
import { RoutePaths } from "routes/RouteConfig";
import { TextPluralization } from "components/TextPluralization";
import HtmlUtils from "lib/HtmlUtils";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: GlobalSearchItem;
    index: number;
    showDivider: boolean;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderTopic: React.FC<Props> = (props) => {

    const { data, index, showDivider } = props;
    const link = RoutePaths.TopicViewer.replace(":id", data.id);

    return (
        <React.Fragment key={"seachItem-" + index}>
            <ListItem
                button
                onClick={
                    () => {
                        HtmlUtils.openUrlInNewWindow(link);
                    }
                }
            >
                <GridEx container wrap="nowrap" spacing={1}>
                    <GridEx item>
                        <img src={data.thumbnailUrl} alt={data.title} width="48" />
                    </GridEx>
                    <GridEx item xs>
                        <div>
                            <Typography color="secondary" variant="body1">{data.title}</Typography>
                        </div>
                        <MuiMuted>
                            <Typography variant="caption">
                                <AppResource resource="Common.Literals.TopicText" />
                                <span> &ndash;</span>
                                <span> <TextPluralization count={data.totalPublications} resource="Views.Search.Components.SearchRenderTopic.PublicationText" /></span>
                            </Typography>
                        </MuiMuted>
                    </GridEx>
                </GridEx>
            </ListItem>
            {showDivider && <Divider />}
        </React.Fragment>
    );
};;